import { Bucket_Name } from "../../Utility/Constants";
import { localGetItem } from "../../Utility/Services/CacheProviderService";
import moment from "moment";
import { DateTime } from 'luxon';
import { CurrencySymbol } from "../../Utility/Constants";
import { Box, Tooltip, Typography } from "@mui/material";
import { Colors } from '../../Styles/Colors';
import CommonValidation from "./CommonValidation";

let AWS = require('aws-sdk');
let s3 = new AWS.S3({
    signatureVersion: 'v4',
    region: "ap-south-1",
    params: { Bucket: Bucket_Name },

});

// Amount Format Change To Indian Standard Format (With comma) ---- Starts
const AmountFormat = (InputAmount, showSymbol = true) => {
    const formatpattern = CurrencySymbol === "$" ? /\B(?=(\d{3})+(?!\d))/g : /\B(?=(\d{2})+(?!\d))/g;
    let isNegativeAmount = null;
    const DecimalAmount = (Useramount) => {
        var amount = String(Useramount).split(".")[0];
        var AfterDecimal = String(Useramount).split(".")[1] || "00";
        AfterDecimal = AfterDecimal?.length === 1 ? AfterDecimal + "0" : AfterDecimal?.slice(0, 2);
        amount = amount.toString();
        var lastThree = amount.substring(amount.length - 3);
        var otherNumbers = amount.substring(0, amount.length - 3);
        if (otherNumbers != '')
            lastThree = ',' + lastThree;
        return `${showSymbol ? CurrencySymbol : ""} ` + (isNegativeAmount ? "- " : "") + otherNumbers.replace(formatpattern, ",") + lastThree + "." + AfterDecimal
    }
    const WholeAmount = (Useramount) => {
        var amount = Useramount;
        amount = amount.toString();
        var lastThree = amount.substring(amount.length - 3);
        var otherNumbers = amount.substring(0, amount.length - 3);
        if (otherNumbers != '')
            lastThree = ',' + lastThree;
        return `${showSymbol ? CurrencySymbol : ""} ` + (isNegativeAmount ? "- " : "") + otherNumbers.replace(formatpattern, ",") + lastThree + ".00"
    }
    if (typeof (InputAmount) == "string") {
        isNegativeAmount = InputAmount.includes("-")
        if (InputAmount.includes("-")) { InputAmount = InputAmount.slice(0, 0) + InputAmount.slice(0 + 1) }
        if (InputAmount.includes(".")) {
            return DecimalAmount(InputAmount)
        }
        else {
            return WholeAmount(InputAmount)
        }
    }
    else if (typeof (InputAmount) == "number") {
        isNegativeAmount = InputAmount < 0
        if (InputAmount < 0) {
            InputAmount = InputAmount * -1;
        }
        if (InputAmount % 1 != 0) {
            return DecimalAmount(InputAmount)
        }
        else if (InputAmount % 1 == 0) {
            return WholeAmount(InputAmount)
        }
    }
}
// Amount Format Change To Indian Standard Format (With comma) ---- ends

// Time Converter Change 24 hours formate into 12 hours formate ---- Starts
const Time_convert = (Time) => {
    var gettime = Time.split("T")[1]
    var splittime = gettime.split(".")[0]
    var slicetime = splittime.slice(0, 5)
    var time = slicetime.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [slicetime];

    if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? ' AM' : ' PM';
        time[0] = +time[0] % 12 || 12;
    } else {
        return "Wrong Time Formate"
    }
    return time
}
// Time Converter Change 24 hours formate into 12 hours formate ---- ends

const formatDate = (input, skipDate = false) => {
    let Date = "-"
    try {
        if (input !== null && input !== undefined && input !== "") {
            let datePart = input.match(/\d+/g),
                year = datePart[0].substring(0),
                month = datePart[1], day = datePart[2];
            if (year.length == 4) {
                Date = skipDate ? month + '-' + year : day + '-' + month + '-' + year;
            } else {
                Date = skipDate ? month + '-' + year : year + '-' + month + '-' + day;
            }

        }
        return Date
    } catch (e) {
        return Date
    }
}

const formatDateAndTime = (input) => {
    let date = input.split(" ")[0]
    let time = input.split(" ")[1].split(":")[0] + ":" + input.split(" ")[1].split(":")[1]
    let medium = input.split(" ")[2]
    let dateFormat = formatDate(date)
    let finalDateTime = dateFormat + " " + time + " " + medium

    return finalDateTime

}

const formatDateAndTimeMeth2 = (input) => {
    if (!input) return '';
    let date = input.split("T")[0]
    let time = input.split("T")[1].split(":")[0] + ":" + input.split("T")[1].split(":")[1]
    let dateFormat = formatDate(date)
    let timeFormat = timeOnlyConvert(time)
    let finalDateTime = dateFormat + " | " + timeFormat

    return finalDateTime
}

const formatDateTime = (inputDate) => {
    // for this format "2025-01-08 07:49:00.000000"
    const date = new Date(inputDate);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = (hours >= 12 ? 'PM' : 'AM');
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

let cachedUserInfo = null;
let lastCacheTime = 0;
let cachedInvestigationName = null;

const getCachedUserInfo = () => {
    const now = Date.now();
    if (!cachedUserInfo || now - lastCacheTime > 60000) { // Cache for 1 minute
        try {
            cachedUserInfo = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo") || '{}') : null;
            lastCacheTime = now;
        } catch (e) {
            cachedUserInfo = {};
        }
    }
    return cachedUserInfo;
};

const getCachedInvestigationName = () => {
    if (!cachedInvestigationName) {
        cachedInvestigationName = GetInvestigationName();
    }
    return cachedInvestigationName;
};

const CheckAccessFunc = (Module, MenuName, TabName = null, SubTabName = null, Type) => {
    try {
        // Default access object
        const defaultAccess = {
            viewAccess: true,
            editAccess: true,
            title: ""
        };

        const userInfo = getCachedUserInfo();

        if (!userInfo?.is_user) {
            return defaultAccess;
        }
        
        const { 
            display_name, 
            pharmacy_name, 
            laboratory_name, 
            sublocation_name, 
            store_name,
            radiotherapy_name,
            mrd_name
        } = userInfo;

        let AccessData = userInfo?.data?.modules || []
        if (!AccessData || !Array.isArray(AccessData) || AccessData.length === 0) {
            return MenuName === "Settings" ? { ...defaultAccess, viewAccess: false, editAccess: false } : defaultAccess;
        }

        const moduleMap = {
            "front_office": display_name,
            "Radiology": display_name,
            [getCachedInvestigationName()]: display_name,
            "Pharmacy": pharmacy_name,
            "Laboratory": laboratory_name,
            "Store Sub Location": sublocation_name,
            "Store": store_name,
            "master_record_department": mrd_name,
            "sub_location": display_name,
            "Radiotherapy": radiotherapy_name,
        };

        const actualModule = moduleMap[Module] || Module;
        
        // const moduleData = AccessData.find(data => 
        //      data?.title === actualModule || data?.sub_name === display_name
        // );
        const moduleData = AccessData.find(data => 
            data?.module_name === actualModule || data?.label === display_name
        )?.module_access[0];
        
        if (!moduleData || !moduleData.data) {
            return MenuName === "Settings"
                ? { ...defaultAccess, viewAccess: false, editAccess: false }
                : defaultAccess;
        }

        let accessObject;

        switch (Type) {
            case 'Menu':
                accessObject = moduleData.data.find(data => data?.title === MenuName);
                break;

            case 'Tab':
                if (!TabName) return defaultAccess;
                const menuData = moduleData.data.find(data => data?.title === MenuName);
                accessObject = menuData?.main_tabs?.find(tab => tab?.title === TabName);
                break;

            case 'SubTab':
                if (!TabName || !SubTabName) return defaultAccess;
                const menuForSub = moduleData.data.find(data => data?.title === MenuName);
                const tabData = menuForSub?.main_tabs?.find(tab => tab?.title === TabName);
                accessObject = tabData?.sub_tabs?.find(subTab => subTab?.title === SubTabName);
                break;

            default:
                accessObject = undefined;
        }

        return accessObject !== undefined ? accessObject :
            (MenuName === "Settings"
                ? { ...defaultAccess, viewAccess: false, editAccess: false }
                : defaultAccess);

    } catch (e) {
        return {
            viewAccess: true,
            editAccess: true,
            title: ""
        };
    }
};

// clear cache when needed (e.g., on logout)
const clearAccessCache = () => {
    cachedUserInfo = null;
    lastCacheTime = 0;
    cachedInvestigationName = null;
};

const splitDate = (value) => {
    let date = value?.split("T")[0]
    return formatDate(date)
}

const timeOnlyConvert = (time) => {
    const [hourString, minute] = time.split(":");
    const hour = +hourString % 24;
    const hours = hour?.length < 10 ? ('0' + hour) : hour
    return (hours % 12 || 12) + ":" + minute + (hours < 12 ? " AM" : " PM");
}

const DifferntTimeConverter = (timeString) => {
    var dateTime = new Date(timeString);
    var formattedTime = dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return (formattedTime);
}

const removeSpaces = (value) => {
    return value.replace(/\s+/g, ''); // Removes all spaces
}

const removeHyphen = (value) => {
    return value.replace(/-/g, ''); // Removes all spaces
}

const CalculateAgeFromDob = (date) => {
    // let age = "";
    // let dob = DateTime.fromJSDate(date);
    // var year_age = DateTime.now().diff(dob, 'years');
    // age = Math.floor(year_age.years) || 0;
    // return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
    let age = "";
    let dob = new Date(date);
    let m = moment(dob, "DD-MM-YYYY");
    var end_date = moment();

    var year_age = end_date.diff(m, 'year') || 0;
    // reset(year) year with difference year
    m = moment(m).add(year_age, 'years');

    var month_age = end_date.diff(m, 'month') || 0;
    // reset(month) month with difference month
    m = moment(m).add(month_age, 'months');

    var day_age = end_date.diff(m, 'days') || 0;

    if (year_age > 0) {
        age = year_age || 0;
    } else {
        age = year_age + "Y/" + month_age + "M/" + day_age + "D";
    }
    return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
}

const CalculateApproxDOB = ageEntered => {

    var year = 0;
    var month = 0;
    var days = 0;
    var tempDate;
    year = +(ageEntered)
    if (!year) {
        tempDate = null;
    } else {
        tempDate = DateTime.now().minus({ years: year }).toBSON();
    }

    return tempDate;
}

// AWS STORAGE LIMIT FOR CLINIC

const getClinicS3Storage = async (clinic_id) => {
    let totalSize = 0,
        ContinuationToken;
    do {
        let resp = await s3
            .listObjectsV2({
                Bucket: Bucket_Name,
                Prefix: `${Bucket_Name}/${clinic_id}/`, ContinuationToken,
            })
            .promise()
            .catch((e) => console.log(e));
        resp.Contents.forEach((o) => (totalSize += o.Size));
        ContinuationToken = resp.NextContinuationToken;
    } while (ContinuationToken);
    console.log("S3 BUCKETS::::", totalSize); //your answer
    let bytes = totalSize;
    let decimals = 2;
    let bucketSize = 0;
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    bucketSize = `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]
        }`;
    console.log("S3 BUCKETS::::", bucketSize);
    return totalSize;
}

const ConvertTimeToDate = (formatedTime) => {
    const currentDate = new Date();

    const [time, amPm] = formatedTime.split(' ');
    const [hours, minutes] = time.split(':');

    const hoursNumeric = parseInt(hours);
    const minutesNumeric = parseInt(minutes);

    currentDate.setHours(hoursNumeric, minutesNumeric);

    // If the time is in PM, add 12 hours to the hoursNumeric
    if (amPm === "PM" && hoursNumeric !== 12) {
        currentDate.setHours(hoursNumeric + 12);
    }
    return currentDate;
}

const calculateBMI = (weight, height) => {
    // Convert height from centimeters to meters
    height = +height / 100;

    // Calculate BMI
    const bmi = +weight / ((+height) * (+height));

    return bmi;
}

const calculateBSA = (height, weight) => {
    const h = Number(height);
    const w = Number(weight);

    if (!h || !w || h <= 0 || w <= 0) {
        return 0;
    }

    const bsa = 0.007184 * Math.pow(h, 0.725) * Math.pow(w, 0.425);
    return bsa;
}

const FindCreditType = Data => {
    let CreditType = "Patient credit"
    for (let i = 0; i <= Data?.length; i++) {
        if (Data[i]?.credit_type) {
            CreditType = Data[i]?.credit_type
            break
        }
    }
    return CreditType;
}

const ProfitLossPercent = (original, compare) => {
    let Value = 0
    let originalValue = original ? original : 0
    let CompareValue = compare ? compare : 0
    Value = (originalValue - CompareValue)
    return Math.round(Value)

}

const getLabS3Storage = async (Lab_ID) => {
    let totalSize = 0,
        ContinuationToken;
    do {
        let resp = await s3
            .listObjectsV2({
                Bucket: Bucket_Name,
                Prefix: `${Bucket_Name}/` +
                    Lab_ID +
                    "/",
                ContinuationToken,
            })
            .promise()
            .catch((e) => console.log(e));
        resp?.Contents?.forEach((o) => (totalSize += o.Size));
        ContinuationToken = resp?.NextContinuationToken;
    } while (ContinuationToken);
    console.log("S3 BUCKETS::::", totalSize); //your answer
    let bytes = totalSize;
    let decimals = 2;
    let bucketSize = 0;
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    bucketSize = `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]
        }`;
    console.log("S3 BUCKETS::::", bucketSize);
    return totalSize;
}

const formatToCustomDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

const convertDateTime = (inputDateTime) => {
    //  Example usage:
    //  Input "2023-12-27T14:07:11"
    //  Output '27-12-2023 | 2:07 PM';
    const date = new Date(inputDateTime);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    const formattedDate = `${day}-${month}-${year}`;

    let amOrPm = 'AM';
    let formattedHours = parseInt(hours);

    if (formattedHours >= 12) {
        amOrPm = 'PM';
        if (formattedHours > 12) {
            formattedHours -= 12;
        }
    }

    const finalDateTime = `${formattedDate} | ${formattedHours}:${minutes} ${amOrPm}`;
    return finalDateTime;
}

const convertDateSlashToHyphen = (date) => {
    let [day, month, year] = date?.split('/');
    return `${year}-${month}-${day}`;
}

const reformatDateTime = (dateStr) => {
    if (!dateStr) return '';
    // Split the date and time parts
    let [datePart, timePart] = dateStr.split(' ');

    // Reformat the date part (YYYY-MM-DD to DD-MM-YYYY)
    let [year, month, day] = datePart.split('-');
    let formattedDate = [day, month, year].join('-');

    // Combine the formatted date with the time part
    return `${formattedDate} ${timePart}`;
}

const areValuesNotEmptyExceptKeys = (obj, keysToExclude) => {
    for (let key in obj) {
        if (!keysToExclude.includes(key) &&
            obj[key] !== null &&
            obj[key] !== undefined &&
            obj[key] !== false &&
            obj[key] !== 0 &&
            obj[key] !== '' &&
            !(Array.isArray(obj[key]) && obj[key].length === 0) && // Check for empty array
            !(typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) // Check for empty object
        ) {
            return true; // If a non-empty value is found for a key other than the excluded keys
        }
    }
    return false; // Return false if all values are empty or excluded
};

const calculateWeeksAndDays = (fromDate, toDate) => {
    const msInDay = 24 * 60 * 60 * 1000;
    const diffInMs = toDate - fromDate;
    const totalDays = Math.floor(diffInMs / msInDay);
    const weeks = Math.floor(totalDays / 7);
    const days = totalDays % 7;
    return { weeks, days };
};

//   // Example usage:
//   const inputDateTime = '2023-12-27T09:46:21';
//   const convertedDateTime = convertDateTime(inputDateTime);
//   console.log(convertedDateTime);

const ContentInTooltip = (text = '', maxLength = 7, fontSize = "1vw", fontWeight = 500, marginX = 0, color = 'black') => {
    return <Box component={'div'} sx={{ marginX: marginX }}>
        {text ? text?.length > maxLength ?
            <Tooltip placement='top' title={text} arrow>
                <Typography sx={{ fontSize: fontSize, fontWeight: fontWeight, color: color }}>{text.slice(0, (maxLength - 2)) + "..."}</Typography></Tooltip> :
            <Typography sx={{ fontSize: fontSize, fontWeight: fontWeight, color: color }}>{text}</Typography> : "-"}</Box>
}

const OpenDirectPrint = (response) => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const container = document.createElement('div');
    const shadowRoot = container.attachShadow({ mode: 'closed' });

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = fileURL;

    shadowRoot.appendChild(iframe);
    document.body.appendChild(container);

    iframe.onload = function () {
        try {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();

        } catch (error) {
            console.log("Print error:", error);
        }

    }
}

const debounce = (func, delay = 500) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
}

const CheckCashCounterAccess = () => {
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    if (localGetItem('isNewBilling') === "false") {
        return false
    } else if (loggedInUserInfo?.is_user) {
        if (loggedInUserInfo?.module_name === "front_office") {
            return (loggedInUserInfo?.permission_access?.cash_counter_modules?.includes("FO") || false)
        } else if (loggedInUserInfo?.module_name === "Laboratory") {
            return (loggedInUserInfo?.permission_access?.cash_counter_modules?.includes("Lab") || false)
        } else if (loggedInUserInfo?.module_name === "Radiology") {
            return (loggedInUserInfo?.permission_access?.cash_counter_modules?.includes("Radiology") || false)
        } else if (loggedInUserInfo?.module_name === "Investigation") {
            return (loggedInUserInfo?.permission_access?.cash_counter_modules?.includes(GetInvestigationName()) || false)
        } else if (loggedInUserInfo?.module_name === "Pharmacy") {
            return (loggedInUserInfo?.permission_access?.cash_counter_modules?.includes("Pharmacy") || false)
        }
    } else {
        return true
    }
}

const GetStoreBaseUrl = () => {
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    let StockTransferUrl = `/StoreTransfer`
    if (loggedInUserInfo?.module_name === "store_module") {
        return StockTransferUrl
    } else {
        let StockTransferUrl = `/StoreTransfer`
        if (loggedInUserInfo?.sub_location_module === 'Front Office') {
            return StockTransferUrl = `/FOStoreTransfer`
        } else if (loggedInUserInfo?.sub_location_module === 'LAB') {
            return StockTransferUrl = `/LabStoreTransfer`
        } else if (loggedInUserInfo?.sub_location_module === 'Radiology') {
            return StockTransferUrl = `/RadiologyStoreTransfer`
        } else if (loggedInUserInfo?.sub_location_module === 'Pharmacy') {
            return StockTransferUrl = `/PharmacyStoreTransfer`
        } else {
            return StockTransferUrl = `/StoreTransfer`
        }
    }
}

const renderCorpInsuranceCard = (label, value, width = "15dvw") => {
    return (
        <Box component={'div'} className='doc_header_card_New'
            sx={{ width: width, display: 'flex', flexDirection: 'column', justifyContent: "center", paddingLeft: "0.5dvw", marginTop: "0.5vw" }} mr={'0.3vw'}>
            <Typography color={Colors.Primary} fontSize={'0.7vw'} fontWeight={600} m={'0.2vw'}>{label}</Typography>
            {value?.length > 25 ?
                <Tooltip title={value} placement='top' arrow><Typography fontSize={'0.7vw'} fontWeight={600} m={'0.2vw'}>{value?.slice(0, 25) + '...'}</Typography></Tooltip> :
                <Typography fontSize={'0.7vw'} fontWeight={600} m={'0.2vw'}>{value}</Typography>}
        </Box>
    )
}

const dataURItoFile = (dataURI, fileName) => {
    let byteString = atob(dataURI.split(',')[1]);
    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    let blob = new Blob([ab], { type: mimeString });

    // Convert Blob to File with a proper filename
    return new File([blob], fileName, { type: mimeString });
};

const GetInvestigationName = (smallCase = false) => {
    // this hits only in scopy, audiometry, radiology - for return module name for dynamic router
    const InvestigationName = localGetItem('investigation_name') ? localGetItem('investigation_name') : "Radiology"
    if (localGetItem('isNewBilling') !== "true") {
        return smallCase ? 'radiology' : `Radiology`
    } else if (InvestigationName) {
        return InvestigationName
    } else {
        return smallCase ? 'radiology' : `Radiology`
    }
}

const checkTransationMandatory = () => {
    let hasAccess = JSON.parse(localGetItem('is_transaction_number_mandatory')) ?? JSON.parse(localGetItem('loggedInUserInfo'))?.is_transaction_number_mandatory
    return hasAccess
}

const getExpenseMaxLimit = () => {
    const rawUserInfo = localGetItem('loggedInUserInfo');
    const rawIsExpenseFlag = localGetItem('is_expense_maximum_enabled');
    const rawExpenseLimit = localGetItem('expense_maximum_amount');

    const userInfo = rawUserInfo ? JSON.parse(rawUserInfo) : {};
    const isExpenseFlag = rawIsExpenseFlag ? JSON.parse(rawIsExpenseFlag) : null;
    const expenseLimit = rawExpenseLimit ? JSON.parse(rawExpenseLimit) : null;

    const hasEnabledExpense = isExpenseFlag !== null && isExpenseFlag !== undefined
        ? isExpenseFlag : userInfo?.is_expense_maximum_enabled;

    const expenseAmount = expenseLimit ?? userInfo?.expense_maximum_amount;

    return hasEnabledExpense && expenseAmount ? expenseAmount : null;
};

const calculateWaitingTime = (data) => {
    if (!data || Object.keys(data)?.length === 0 || !data.patient_arrived_time) return null;
    const convertTime12to24 = moment(data.patient_arrived_time, ["h:mm A"]).format("HH:mm");
    const year = moment(new Date(data.appointment_date)).format("LL") + " " + convertTime12to24 + ":00"
    const current_date = new Date();
    const arrived_date = new Date(year);
    const res = Math.abs(current_date - arrived_date) / 1000;
    const hours = Math.floor(res / 3600) % 24;
    const minutes = Math.floor(res / 60) % 60;

    const result = hours + ' Hr ' + minutes + ' Mins.'
    return result === "NaN Hr NaN Mins." ? "0 Hr 0 Mins." : result;
}

const passwordValidations = (newPass, type) => {
    var passWord = false
    let pass_type = type || localGetItem("password_type")
    var ErrorMsg = ""
    if (pass_type == "strong") {
        passWord = CommonValidation.checkStrongPassword(newPass)
        ErrorMsg = !passWord ? "Password should be 6 characters, one UpperCase,Special Characters,LowerCase" : ""
    }
    else if (pass_type == "standard") {
        passWord = CommonValidation.checkStandardPassword(newPass)
        ErrorMsg = !passWord ? "Password should be 6 characters, AlphaNumeric Values Only" : ""
    }
    else if (pass_type == "numeric") {
        passWord = CommonValidation.checkNumericPassword(newPass)
        ErrorMsg = !passWord ? "Password should be 6 characters, Numeric Values Only" : ""
    }
    return ErrorMsg;
}

export const fetchAndConvertToBase64 = async (url) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader?.result);
            reader.onerror = () => reject(reader?.error);
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error fetching or converting file:', error);
    }
}

export {
    AmountFormat, Time_convert, formatDate, formatDateAndTime, CheckAccessFunc, timeOnlyConvert, clearAccessCache,
    CalculateAgeFromDob, CalculateApproxDOB, DifferntTimeConverter, splitDate, ProfitLossPercent,
    FindCreditType, calculateBMI, getClinicS3Storage, ConvertTimeToDate, formatToCustomDateTime,
    getLabS3Storage, convertDateTime, formatDateAndTimeMeth2, reformatDateTime, areValuesNotEmptyExceptKeys,
    calculateWeeksAndDays, convertDateSlashToHyphen, ContentInTooltip, OpenDirectPrint, debounce,
    formatDateTime, CheckCashCounterAccess, renderCorpInsuranceCard, dataURItoFile, removeSpaces, removeHyphen, calculateBSA, GetStoreBaseUrl, getExpenseMaxLimit,
    checkTransationMandatory, GetInvestigationName, calculateWaitingTime, passwordValidations
}
